import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { CommonService } from '@shared/service/common.service';
import { GenericSliderService } from '@shared/service/genericSlider.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GenericSlidersModel } from '@core/model/genericSliders.model';

@Component({
    selector: 'app-modal-privacy-policies',
    templateUrl: './modal-privacy-policies.component.html',
    styleUrls: ['./modal-privacy-policies.component.scss']
})
export class ModalPrivacyPoliticiesComponent implements OnInit {
    private unsubscribe$ = new Subject<void>();
    logoUrl = '';
    policies: any;
    status: any;
    acceptTerms = false;
    onAdd = new EventEmitter();
    onCancel = new EventEmitter();

    constructor(
        public dialogRef: MatDialogRef<ModalPrivacyPoliticiesComponent>,
        @Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel,
        private common: CommonService,
        private genericSliderService: GenericSliderService
    ) {
        if (this.dataMessage !== null && this.dataMessage !== undefined) {
            this.status = this.dataMessage.status;
        }
    }

    ngOnInit() {
        this.onGetLogo();
        this.onPrivacy();
    }

    onGetLogo() {
        this.genericSliderService.getLogo()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(response => {
                this.logoUrl = response.UrlImage;
        });
    }

    onPrivacy() {
        let model = new GenericSlidersModel();
        model.SliderId = 'POLITICA_PRIVACIDAD';
        this.genericSliderService.getSliderImages(model)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(response => {
            this.policies = response;
        });
    }

    accept() {
        this.onAdd.emit(true);
    }

    cancel() {
        this.dialogRef.close();
        this.onCancel.emit(false);
    }
}
